import React from 'react';
import './style.css';

const MainServices = (props) => {
  let cn = 'capabilities-items-unselected pointer w-100 tc unselectable'

  if (props.isSelected) {
    cn = 'capabilities-items-selected pointer w-100 tc unselectable'
  } else if (props.initialState) {
    cn = 'capabilities-items-initial pointer w-100 tc unselectable'
  }

    return (
        <div onClick={() => {props.onClick(props.serviceName)}} className={cn}>
          { props.serviceName }
          <div className={ props.isSelected ? "capabilities-description-shown" : "capabilities-description-hidden"}>
              <span>{ props.serviceDescription || "&nbsp;" }</span>
          </div>
        </div>
    )
}

export default MainServices



// WEBPACK FOOTER //
// ./src/pages/Home/Sections/Services/MainServices/index.jsx